import React from "react"
import Loadable from "react-loadable"
const Plotly = Loadable({
  loader: () => import(`react-plotly.js`),
  loading: ({ timedOut }) =>
    timedOut ? (
      <blockquote>Error: Loading Plotly timed out.</blockquote>
    ) : (
      <blockquote>Loading...</blockquote>
    ),
  timeout: 10000,
})

export default ({ layout, style, config, ...rest }) => {
  return (
    <Plotly
      layout={{
        // margin: { t: 10, r: 10, b: 10, l: 10 },
        paper_bgcolor: `rgba(0, 0, 0, 0)`,
        plot_bgcolor: `rgba(0, 0, 0, 0)`,
        // font: {
        //   color: "white",
        //   size: 16,
        // },
        // The next 3 options make the plot responsive.
        autosize: true,
        ...layout,
      }}
      style={{ width: `100%`, ...style }}
      useResizeHandler
      config={{
        displayModeBar: false,
        showTips: false,
        ...config,
      }}
      {...rest}
    />
  )
}
